<template>
  <div
    class="flex flex-nowrap items-center py-1.5 pl-3 pr-2 gap-2 rounded-lg bg-blue-500 text-white"
  >
    <p class="text-xs font-semibold">{{ title }}</p>

    <div
      class="w-[18px] h-[18px] cursor-pointer flex items-center justify-center bg-white rounded-full"
      @click="removeBadge"
    >
      <i class="text-[10px] font-bold text-blue-500 pi pi-times p-1"></i>
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  title: string;
}>();

const emit = defineEmits(["remove-badge"]);

function removeBadge() {
  emit("remove-badge", props.title);
}
</script>
